import React from 'react';


// import animate on scroll
import Aos from 'aos';
import 'aos/dist/aos.css';

// import components
import Hero from './components/Hero';
import Aboutdoa from './components/Aboutdoa';
import CtaSection from './components/CtaSection';
import Footer from './components/Footer';
import Team from './components/Team';
import Doa from './components/Doa'

const Doaharian = () => {
  // animate on scroll initialization
  Aos.init({
    duration: 1800,
    offset: 0,
  });
  return (
    <div className='overflow-hidden'>
      <Hero />
      <Aboutdoa />
      <Doa />
      <CtaSection />
      <Footer />
    </div>
  );
};

export default Doaharian;
